import React from 'react';
import {connect} from 'react-redux';
import {Checkbox} from "react-bootstrap";
import PaymentMethods from "../../components/pay/PaymentMethods";
import {setSelectedMethod, setComments, setHomeDeliveryInstructions, setTermsSelected} from "../../actions/join/joinActions";
import {PaymentPlanRestrictions, URLs, PaymentPlans, PaymentMethod, FetchingTypes} from '../../common/constants';
import {isFetching} from "../../actions/common/fetchingActions";
import styles from "../../css/join/joinPayStep.less";
import {translate} from '../../i18n/translate.js';

class JoinPayStep extends React.Component {
    state = {comments: this.props.signupComments, homeDeliveryInstructions: this.props.homeDeliveryInstructions};

    componentWillMount() {
        if(this.props.paymentMethod) {
            this.setSelectedMethod(this.props.paymentMethod);
        }
    }

    setSelectedMethod = (key) => {
      this.props.setSelectedMethod(key);
    };

    setCommentsToState = (event) => {
        this.setState({comments: event.target.value});
        if (this.props.staticData.mandatorySignupComments) {
            this.props.setComments(event.target.value);
        }
    };

    setCommentsToStore = () => {
        this.props.setComments(this.state.comments);
    };

    setHomeDeliveryInstructionsToState = (event) => {
        this.setState({homeDeliveryInstructions: event.target.value});
    };

    setHomeDeliveryInstructionsToStore = () => {
        this.props.setHomeDeliveryInstructions(this.state.homeDeliveryInstructions);
    };

    //Checks if payment plan properties look like it's a trial sign up and therefore member couldn't use automatic payment service
    isTrialSignup = (plan) => {
        return (plan.type === PaymentPlans.P || plan.type === PaymentPlans.DynamicPrePayment || plan.type == PaymentPlans.DistributionDynamicPrePayment) && !plan.isSupportAutomatic;
    };

    filterPaymentMethodsByPaymentPlan = () => {
        const isTrialSignup = this.isTrialSignup(this.props.selectedPaymentPlan);
        const paymentPlanType = this.props.selectedPaymentPlan.type;
        const allowedPaymentMethods = PaymentPlanRestrictions[paymentPlanType];
        if(allowedPaymentMethods){
                return this.props.staticData.signupPaymentMethods.filter(paymentMethod => {
                    //first check if the plan supports preapproval
                    if (isTrialSignup && [PaymentMethod.PAYPAL_PREAPPROVE.key, PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key, PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key].includes(paymentMethod))
                        return false;
                return allowedPaymentMethods.includes(paymentMethod);
            });
        }
    };

    handleTermsChange = (event) => {
        this.props.setTermsSelected(event.target.checked);
    }

    renderTerms = () => {
        if (this.props.staticData.joinTermsAgreement) {
            return (
                <div className="join-pay-terms-agreement">
                    <span dangerouslySetInnerHTML={{__html: this.props.staticData.joinTermsAgreement}}/>
                </div>
            )
        }
        return (
            <div className="join-pay-terms-agreement">
                <Checkbox inline={true}
                          checked={this.props.termsChecked}
                          onChange={this.handleTermsChange}>
                    <span>I have read and agree to the <a className="join-pay-terms-agreement-link" href={this.props.staticData.termsUrl}
                        target="_blank">terms & conditions</a> of {this.props.staticData.farmName}</span>
                </Checkbox>
            </div>
        )
    }

    render() {
        const commentsLabel = this.props.staticData.signupCommentsLabel;
        const paymentMethods = this.props.hasPreappvoal ? [this.props.preapprovalMethod] : this.filterPaymentMethodsByPaymentPlan();
        return (<fieldset disabled={this.props.showLoading} className="checkout-content join-pay-container">
            <PaymentMethods paymentMethods={paymentMethods}
                            setSelectedMethod={this.setSelectedMethod}
                            hasPreapproval={this.props.hasPreappvoal}
                            pageContext={URLs.JOIN}
                            isAddSubscription={this.props.isAddSubscription}
                            selectedMethod={this.props.selectedMethod}/>
            {   this.props.isHomeDelivery && !this.props.isAddSubscription &&
                <div className="text-area">
                    <h5>Special Home Delivery Instructions (If required include: gate code, where to leave your order, etc.)</h5>
                    <textarea className="input-text" type="text" rows="3" value={this.state.homeDeliveryInstructions}
                              onChange={this.setHomeDeliveryInstructionsToState}
                              onBlur={this.setHomeDeliveryInstructionsToStore}/>
                </div>
            }
            {
                commentsLabel && commentsLabel !== 'null' && !this.props.isAddSubscription ?
                    <div className="text-area">
                        <h5 dangerouslySetInnerHTML={{__html: commentsLabel}}/>
                        <textarea className="input-text" type="text" rows="3" value={this.state.comments}
                                  onChange={this.setCommentsToState} onBlur={this.setCommentsToStore}/>
                    </div>
                    : undefined
            }
            <div className="join-pay-terms-bottom">
                {this.renderTerms()}
            </div>
        </fieldset>);
    }
}

const mapStateToProps = (state) => {
    const signupData = state.signupData || {};
    const selectedData = (signupData || {}).selectedData;
    const summary = (state.summary || {});
    return {
        staticData: state.staticData || {},
        selectedMethod: selectedData.selectedMethod,
        signupComments: selectedData.signupComments,
        homeDeliveryInstructions: selectedData.homeDeliveryInstructions,
        isHomeDelivery: summary.pickupSite && 'Zone' === summary.pickupSite.type,
        selectedPaymentPlan: selectedData.selectedPaymentPlan,
        isAddSubscription: signupData.isAddSubscription,
        paymentMethod: summary.paymentMethod,
        hasPreappvoal: summary.hasPreapproval,
        preapprovalMethod: summary.paymentMethod,
        showLoading: isFetching(state, FetchingTypes.SUBMIT),
        termsChecked: selectedData.termsChecked
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedMethod: (key) => {
            dispatch(setSelectedMethod(key));
        },
        setComments: (comments) =>{
            dispatch(setComments(comments));
        },
        setTermsSelected: (isSelected) =>{
            dispatch(setTermsSelected(isSelected));
        },
        setHomeDeliveryInstructions: (instructions) =>{
            dispatch(setHomeDeliveryInstructions(instructions));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)( JoinPayStep );



// WEBPACK FOOTER //
// ./src/containers/join/JoinPayStep.js